import qrcode from "qrcode-generator";

/**
 * The QR code of a URL as one SVG path, one 1x1 square per dark module,
 * with the standard 4-module quiet zone around it. `size` is the whole
 * square, quiet zone included, in modules.
 *
 * Shared by the ambassador page QR and the "Book on the app" QR.
 */
export function qrModules(url: string): { size: number; count: number; dark: (r: number, c: number) => boolean } {
  const qr = qrcode(0, "M");
  qr.addData(url, "Byte");
  qr.make();
  const count = qr.getModuleCount();
  return { size: count + 8, count, dark: (r, c) => qr.isDark(r, c) };
}

export function qrPath(url: string): { size: number; d: string } {
  const { size, count, dark } = qrModules(url);
  let d = "";
  for (let r = 0; r < count; r += 1) {
    for (let c = 0; c < count; c += 1) {
      if (dark(r, c)) d += `M${c + 4} ${r + 4}h1v1h-1z`;
    }
  }
  return { size, d };
}
